import React from "react";
import { useTranslation } from "react-i18next";
import Badge from "components/basic/badge";
import { TicketStatus } from "generated/graphql";

import { STATUS_COLORS, STATUS_LABELS } from "../../constants";

const TicketStatusBadge: React.FC<{ status: TicketStatus }> = ({ status }) => {
  const { t } = useTranslation("support");

  return (
    <Badge label={t(STATUS_LABELS[status])} color={STATUS_COLORS[status]} />
  );
};

export default TicketStatusBadge;
